
import pkHeader from  '../common/header/header.vue';
import Scroll from '../common/scroll'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default{
data(){
return {
defaul:false,
title:'接送订单详情',
serverphone:localStorage.getItem('serverphone')||"400-667-5757",
state_n:'已拒单',
Opinion:"",//意见
roate:1,//星级
labels:"",
orderInfo:{
orderState:"compile"
},//订单详情
dirverInfo:[],//司机详情
activityName:"1",
Confirm:"",
shows:false,
show2:false,
shows_phone:false,
bizType:"1",
bizTypec:"1",
activeFlag:true,
show_textarea:true,
show_labels:true,
refundPrice:"",//退款价格
isComment:true,//是否已经评价
isCall:true,//是否可打电话
isup:true,//是否已上车
userToken:this.$until.getUrlParam('openId') || localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid"),
}
},
components:{
pkHeader,
Cell,
Group,
Radio,
XButton,
Rater,
XDialog,
Badge,
Confirm
},
computed:{
count:function(){
var n = 0;
return this.Opinion && (n = this.Opinion.replace(/\n/g,"aa").length),
180 - (n > this.max ? this.max : n)
}
},
created() {
this.$store.dispatch('showLoading')
this.$http.post(window.innerAPI + '?server=orderInfo',{
"_p_from":localStorage.getItem("appFrom"),
"orderNo":this.$route.params.id,
"bizTypeStr":this.$route.params.bizType,
"userToken":this.userToken
}).then((res) =>{
this.orderInfo = res.data.data
this.isup = res.data.data.isup==1?true:false

this.isCall = res.data.data.isCall==1?true:false
this.orderInfo.bookDate = Date.parse1(this.orderInfo.bookDate).format('MM月dd日')
this.bizType = res.data.data.bizType
if (this.bizType == "2"){
this.bizTypec = "CAR_PASSENGER_STATION_PICK"
} else if (this.bizType == "3"){
this.bizTypec = "CAR_PASSENGER_STATION_TAKE"
} else if (this.bizType == "5"){
this.bizTypec = "CAR_PASSENGER_AIRPORT_PICK"
} else if (this.bizType == "6"){
this.bizTypec = "CAR_PASSENGER_AIRPORT_TAKE"
}

if (this.orderInfo.orderState == 'success' || this.orderInfo.orderState == 'compile'){
this.queryDriverInfo()
}
if (this.orderInfo.orderState == 'compile'){
this.getLabels()
}
setTimeout(()=>{
this.$store.dispatch('hideLoading')
this.defaul = true
},1000)
})

},
mounted(){

},
methods:{

changeActive(){
event.target.setAttribute('class',event.target.getAttribute('class') === 'active' ? '' : "active")
},
queryDriverInfo(){
this.$http.post(window.innerAPI + '?server=queryDriverInfo',{
"_p_from":localStorage.getItem("appFrom"),
"orderNo":this.$route.params.id,
"userToken":this.userToken,
"bizType":this.bizType
}).then((res) =>{
this.dirverInfo = res.data.data.data[0]
if (!this.dirverInfo){
this.dirverInfo = []
}
})
},
getLabelss(){
this.$http.post(window.innerAPI + '?server=getLabels',{
"_p_from":localStorage.getItem("appFrom"),
"userToken":this.userToken,
"server1":this.bizTypec,
}).then((res) =>{
console.log(res.data.data.labelInfo.labelsDtos)
if (res.data.data.labelInfo.labelsDtos.length == 0){
this.show_textarea = false;
this.show_labels = false
return false;
}
if (res.data.data.labelInfo.labelsDtos[0].level == "0"){
this.show_labels = false
}
if (!res.data.data.isMsg||res.data.data.isMsg=="0"){
this.show_textarea = false;
}
var level = {},
levels = {};
let labelsD = res.data.data.labelInfo.labelsDtos
if (labelsD){
for(let i = 0; i < labelsD.length; i++) {
level = {};
for(let j = 0; j < labelsD[i].labels.split("|").length; j++) {
level[j] = labelsD[i].labels.split("|")[j]
}
levels[i] = level
}
}
if (res.data.data.labelInfo.labelsDtos[0].level == "1|2|3|4|5"){
levels[1] = level;
levels[2] = level;
levels[3] = level;
levels[4] = level;
}
this.labels = levels;
})
},
getLabels(){//设置评价标签
this.$http.post(window.innerAPI + '?server=getCommentRecord',{
"_p_from":localStorage.getItem("appFrom"),
"orderIds":this.$route.params.id,
"userToken":this.userToken,
"server1":this.bizTypec
}).then((res) =>{
this.labels = ''
if (res.data.data.code || res.data.data.state == "0" || !res.data.data.data[0]){
this.getLabelss()
return false;
}
this.show_labels = true
if(res.data.data.data[0].level){
this.isComment = false
}
this.Opinion = res.data.data.data[0].content
if(!this.Opinion){this.show_textarea = false}
this.roate = parseInt(res.data.data.data[0].level)
var level = {};
for(var i = 0; i < res.data.data.data[0].labels.split('|').length; i++) {
level[i] = res.data.data.data[0].labels.split('|')[i]
}
(level[0] != "") && (this.labels = level);
})
},

comment(){
var me = this
,t = [];
if (me.roate < 1){
this.$vux.toast.show({
text:"请选择星级",
type:"text"
})
return;
}
for(var a = "",s = 0; s < document.getElementsByClassName('active').length; s++)
a += document.getElementsByClassName('active')[s].innerHTML + "|";
a = a.substr(0,a.length - 1),
t.push({
orderIds:this.$route.params.id,
server:this.bizTypec,
level:this.roate,
content:this.Opinion,
labels:a
});
t = JSON.stringify(t);
var dat = {
_p_from:localStorage.getItem("appFrom"),
commentInfo:t,
userToken:this.userToken
};
this.$http.post(window.innerAPI + '?server=execCommentCommon',dat).then((res) =>{
if (res.data.data.code == "S001"){
this.$vux.toast.show({
text:"评价成功",
type:"text"
})
setTimeout(function(){
location.reload();
},1000);
} else {
this.$vux.toast.show({
text:res.data.data.errmsg,
type:"text"
})
}
})
},

cancalv(){
this.shows = false
this.$http.post(window.innerAPI + '?server=refundOrder',{
"_p_from":localStorage.getItem("appFrom"),
"userToken":this.userToken,
"orderId":this.$route.params.id,
"refundPrice":this.refundPrice,
"reason":""
}).then((res) =>{
var msg = '退款成功'
if(!res.data.state){
msg = '退款失败'
}
this.$vux.toast.show({
text:msg,
type:"text"
})
setTimeout(function(){
location.reload();
},1000);
})
},
calldrive(){
if(!this.isCall){
this.shows_phone = true
}else{
this.calldriver()
}
},
calldriver(v){
if(!this.isCall&&v){
location.href = "tel:"+ this.serverphone;
}else{
location.href = "tel:" + this.dirverInfo.phone
}
this.shows_phone = false
},

showdialog(){
this.$http.post(window.innerAPI + '?server=queryRefundPrice',{
"_p_from":localStorage.getItem("appFrom"),
"userToken":this.userToken,
"bizTypeStr":this.bizType,
"orderNo":this.$route.params.id,
}).then((res) =>{
/*
贵州
if(!res.data.state){
location.reload();

return;
}*/
if(res.data.data.code){
this.$vux.toast.show({
text:res.data.data.errmsg,
type:"text"
})
setTimeout(function(){
location.reload();
},1000)
return;
}
this.refundPrice = res.data.data.data.refundPrice
this.shows = true
})
}
}
}





// WEBPACK FOOTER //
// ./src/components/order/orderDetail.vue